import { render, staticRenderFns } from "./editPdf.vue?vue&type=template&id=037159a0&scoped=true"
import script from "./editPdf.vue?vue&type=script&lang=js"
export * from "./editPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037159a0",
  null
  
)

export default component.exports